import React from 'react';
import './Topbar.css';

export default function Topbar() {
  return (
    <>
      <section id="top-bar">
        <div className="item">
          <i className="fas fa-envelope"></i> info.appolloagency.com
        </div>
        <div className="item">
          <i className="fas fa-phone-alt"></i>+919884226561
        </div>
        <div className="item">
          <i className="fas fa-map-marker-alt"></i> Chennai
        </div>
        <div className="item">
          <i className="fab fa-whatsapp"></i>9841584115
        </div>
      </section>
    </>
  );
}
